import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import ComicButton from "../../shared/components/ComicButton/ComicButton";
import { unsubscribe as apiUnsubscribe } from "../../core/api/api";

const Unsubscribe = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(t("unsubscribe.processing") || "Procesando...");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    if (!email) {
      setStatus(t("unsubscribe.noEmail"));
      return;
    }

    apiUnsubscribe(email)
      .then(() => {
        setStatus(t("unsubscribe.success"));
      })
      .catch((error) => {
        console.error("Error en la baja:", error);
        setStatus(error.response?.data?.message || t("unsubscribe.error"));
      });
  }, [location.search, t]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white p-4">
      <div className="max-w-md text-center">
        <h1 className="text-3xl font-bold mb-4">
          <Trans i18nKey="unsubscribe.title">Cancelar suscripción</Trans>
        </h1>
        <p className="mb-4">{status}</p>
        <ComicButton
          buttonName={<Trans i18nKey="unsubscribe.buttonBack">Volver al inicio</Trans>}
          hoverBtnName={<Trans i18nKey="unsubscribe.buttonBack">Volver al inicio</Trans>}
          handleButtonClick={() => navigate("/")}
        />
      </div>
    </div>
  );
};

export default Unsubscribe;
